/* eslint-disable complexity */
import { FeatureVariablesType, ModelToggleEnabledType } from '../../types';

const checkForCID = (
  featureVariable: FeatureVariablesType,
  getBrandCID: string,
  cid: string
) => {
  if (!featureVariable || !featureVariable[getBrandCID]) {
    return false;
  }

  if (featureVariable[getBrandCID] === 'all') {
    return true;
  }

  return !!featureVariable[getBrandCID]
    .split(',')
    .filter(value => value === cid).length;
};

const modelToggleEnabled = ({
  featureVariables,
  enabledFeatures,
  abSeg,
  market,
  abbrBrand,
  cid
}: ModelToggleEnabledType) => {
  const modelToggleFeature = `cat-model-toggle-${market}`;
  const getBrandCID = `${abbrBrand}CIDs`;

  if (!featureVariables) {
    return false;
  }

  const isModelFeatureVariableAvailableForCID = checkForCID(
    featureVariables[modelToggleFeature],
    getBrandCID,
    cid
  );

  return (
    abSeg &&
    (abSeg[`${abbrBrand}44`] === 'a' || abSeg[`${abbrBrand}44`] === 'b') &&
    enabledFeatures &&
    enabledFeatures[modelToggleFeature] &&
    isModelFeatureVariableAvailableForCID
  );
};

export default modelToggleEnabled;
